import { render, staticRenderFns } from "./rencaizhengce.vue?vue&type=template&id=fb726c74&scoped=true"
import script from "./rencaizhengce.vue?vue&type=script&lang=js"
export * from "./rencaizhengce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb726c74",
  null
  
)

export default component.exports